module.exports = __webpack_public_path__ + "img/ep-P-dosis.4d1312d1.jpg";